import { useEffect, useRef } from 'react'

export function useSentryUnblock (): void {
  let mutationObserverRef = useRef<MutationObserver | null>(null)

  try {
    mutationObserverRef.current = new MutationObserver(mutations => {
      let unblockedElements = document.querySelectorAll('svg')

      for (let el of unblockedElements) {
        el.setAttribute('data-sentry-unblock', 'true')
      }
    })
  } catch (err) {}

  useEffect(() => {
    if (mutationObserverRef.current) {
      mutationObserverRef.current.observe(document.body, {
        childList: true,
        subtree: true
      })
    }

    return () => {
      if (mutationObserverRef.current) {
        mutationObserverRef.current.disconnect()
      }
    }
  }, [])
}
